

































import { Component, Prop, Vue } from 'vue-property-decorator'
import AboutUs from '@/components/AboutUs.vue'
import TopMenu from '@/components/TopMenu.vue'
import ContactUs from '@/components/ContactUs.vue'
import TitleSection from '@/components/TitleSection.vue'
import SubSection from '@/components/SubSection.vue'
import axios from 'axios'
const appConfig = require('@/constants/appConfig').default

@Component({
  components: { AboutUs, TopMenu, ContactUs, TitleSection, SubSection }
})
export default class TopPage extends Vue {
  memberList: any = []

  // @Prop()
  created() {
    axios
      .get(appConfig.memberListApi + 'memberList')
      .then(response => {
        this.memberList = response.data
      })
      .catch(reason => {
        console.log(reason)
      })
  }
}
